/* ════════════════════════════════════════════════════════
   PureEthical — pe-utils.js
   Global utilities: money, toast, body lock, a11y
   ════════════════════════════════════════════════════════ */

/* Shopify currency formatting */
window.PE = window.PE || {};

PE.money = function(cents) {
  var amount = (cents / 100).toFixed(2);
  var currency = (window.Shopify && Shopify.currency) || {};
  var symbol   = currency.symbol || '€';
  var iso      = currency.active || 'EUR';
  /* Format: most European currencies use comma decimal; CHF uses period but accepts comma */
  var formatted = amount.replace('.', ',');
  /* CHF: "Fr. 49,16" — EUR: "€49,16" — GBP: "£49.16" */
  if (iso === 'CHF') return 'CHF ' + amount.replace(',', '.');
  if (iso === 'GBP' || iso === 'USD') return symbol + amount;
  /* v27: formato portugues/europeu - "1 234,90 €" */
  if (iso === 'EUR') return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace(/ (?=\d+,)/, ' ') + ' €';
  return symbol + formatted;
};

PE.moneyMeta = function(cents) {
  return (cents / 100).toFixed(2);
};

/* Toast notification */
PE.toast = function(msg, type, duration) {
  var existing = document.getElementById('peToast');
  if (existing) existing.remove();
  var el = document.createElement('div');
  el.id = 'peToast';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  el.className = 'pe-toast pe-toast--' + (type || 'success');
  document.body.appendChild(el);
  setTimeout(function() { el.textContent = msg; }, 60); /* v30 Fase 1J: texto depois de a regiao viva existir, para ser anunciado */
  requestAnimationFrame(function() { el.classList.add('pe-toast--show'); });
  setTimeout(function() {
    el.classList.remove('pe-toast--show');
    setTimeout(function() { if (el.parentNode) el.remove(); }, 300);
  }, duration || 2800);
};

/* Body scroll lock */
PE.lockScroll = function() {
  var sw = window.innerWidth - document.documentElement.clientWidth;
  document.body.style.overflow = 'hidden';
  document.body.style.paddingRight = sw + 'px';
};
PE.unlockScroll = function() {
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
};

/* Query helpers */
PE.qs  = function(s, c) { return (c || document).querySelector(s); };
PE.qsa = function(s, c) { return Array.from((c || document).querySelectorAll(s)); };

/* Trap focus in modal */
PE.trapFocus = function(el) {
  var focusable = PE.qsa('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])', el)
    .filter(function(n) { return !n.disabled && n.offsetParent !== null; });
  if (!focusable.length) return;
  var first = focusable[0], last = focusable[focusable.length - 1];
  el._trapHandler = function(e) {
    if (e.key !== 'Tab') return;
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
    }
  };
  el.addEventListener('keydown', el._trapHandler);
  first.focus();
};
PE.releaseFocus = function(el) {
  if (el && el._trapHandler) {
    el.removeEventListener('keydown', el._trapHandler);
    delete el._trapHandler;
  }
};

/* Debounce */
PE.debounce = function(fn, ms) {
  var t;
  return function() {
    var ctx = this, args = arguments;
    clearTimeout(t);
    t = setTimeout(function() { fn.apply(ctx, args); }, ms || 200);
  };
};

/* Expose globals for backwards compat */
window.qs  = PE.qs;
window.qsa = PE.qsa;
window.toast = PE.toast;

/* ── Premium cart bump integration ── */
(function(){
  var orig = window.PE && PE.toast;
  if (typeof orig === 'function') {
    PE.toast = function(msg, type, dur) {
      orig(msg, type, dur);
      if (window.peToast) peToast(msg, type, dur);
    };
  }
})();

/* ── PORTAL do seletor de países no mobile (≤999px) ──
   Ao abrir, move o #countryDrop para o <body> em ecrã inteiro — fora do
   header, imune a transforms, sticky e teclado. Fechado → volta ao normal. */
(function(){
  var mq = window.matchMedia('(max-width: 999px)');
  function init(){
    var drop = document.getElementById('countryDrop');
    var picker = document.getElementById('countryPicker');
    if(!drop || !picker || drop.dataset.peportal) return;
    drop.dataset.peportal = '1';
    new MutationObserver(function(){
      var open = drop.classList.contains('open');
      if(open && mq.matches && drop.parentNode !== document.body){
        document.body.appendChild(drop);
        drop.classList.add('pe-portal');
        document.documentElement.classList.add('pe-portal-lock');
      }
      if(open && !mq.matches && drop.parentNode === document.body){
        drop.classList.remove('pe-portal');
        picker.appendChild(drop);
      }
      if(!open){
        document.documentElement.classList.remove('pe-portal-lock');
        if(drop.parentNode === document.body && !mq.matches){
          drop.classList.remove('pe-portal');
          picker.appendChild(drop);
        }
      }
    }).observe(drop, {attributes:true, attributeFilter:['class']});
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
